import React from 'react';
import { ApplySection } from '../../components/ApplySection';
import AboutUsMissionImg from '../../assets/images/about-us/about-us-our-mission.png';
import AboutUsBg from '../../assets/images/about-us/about-us-bg.jpg';
import './about-us.css';
import { HeroSecondary } from '../../components/HeroSecondary';

import Person1 from '../../assets/images/speakers/person1.png';
import Person2 from '../../assets/images/speakers/person2.png';
import Person3 from '../../assets/images/speakers/person3.png';
import Person4 from '../../assets/images/speakers/person4.png';
import Person5 from '../../assets/images/speakers/person5.png';
import FGLogo from '../../assets/images/about-us/fora-group-logo.png';
import NetworkConversationImg from '../../assets/images/about-us/network-conversation.png';
import AboutUsCard from '../../components/AboutUsCard';
import Button from '../../components/Button';

function AboutUsPage() {
  const team = [
    {
      id: 1,
      name: 'Che Chang',
      position: 'Deputy General Counsel',
      photo: Person1,
    },
    {
      id: 2,
      name: 'Che Chang',
      position: 'Deputy General Counsel',
      photo: Person2,
    },
    {
      id: 3,
      name: 'Che Chang',
      position: 'Deputy General Counsel',
      photo: Person3,
    },
    {
      id: 4,
      name: 'Che Chang',
      position: 'Deputy General Counsel',
      photo: Person4,
    },
    {
      id: 5,
      name: 'Che Chang',
      position: 'Deputy General Counsel',
      photo: Person5,
    }
  ];

  return (
    <div className="about-us-page">
      <HeroSecondary
        title="Where the Most Impactful AI Events Unfold"
        bgImage={AboutUsBg}
      />
      <div className="row flex-wrap about-us-row">
        <h2>The <span className="gradient">largest and most influential</span> arena for AI-related commerce and technological progress.</h2>
        <p>At Ai4, we are dedicated to bring together leaders of enterprise from various sectors, including government organizations, disruptive startups, investors, research labs, academia, associations, open source projects, media, and analysts.</p>
      </div>
      <div className="row flex-wrap mission-row">
        <img src={AboutUsMissionImg} alt="Our mission" />
        <div>
          <h4 className="aa_subtitle">
            Our mission
          </h4>
          <h2>
            We empower responsible AI collaboration.
          </h2>
          <p className="body_dt">
            Through our events, we hope to further establish ourselves as the global epicenter of the AI community. We help provide a common framework for what AI means to both enterprise and the future of our globe as we transition into a new era of responsible human-machine collaboration.
          </p>
        </div>
      </div>
      <div className="about-us-team">
        <h1>Our Team</h1>
        <div className="row flex-wrap team-wrapper">
          {
            team.map(person => (
              <AboutUsCard person={person} />
            ))
          }
        </div>
      </div>
      <div className="row flex-wrap fora-group-row">
        <img src={FGLogo} alt="Fora group" />
        <div>
          <h2>Powered by Fora Group: Uniting Technology Events</h2>
          <p className="body_dt">Brought to you by Fora Group, the renowned organizer behind some of North America's fastest growing technology events. Since our establishment in 2018, we have successfully convened over 10,000 industry leaders from around the world. Our events have attracted hundreds of unique sponsors and partners, including globally renowned technology providers such as Microsoft, IBM, and AWS.</p>
        </div>
      </div>
      <div className="row flex-wrap network-row">
        <div className="network-row-image">
          <img src={NetworkConversationImg} alt="Network conversation" />
        </div>
        <div className="network-row-content">
          <h4 className="aa_subtitle">
            in other news...
          </h4>
          <h3>
            Marcus Jecklin & Michael Weiss speak on a panel about their startup journey as well as AI industry trends, ethics, and more.
          </h3>
          <Button label="Watch video" type="secondary" />
        </div>
      </div>
      <ApplySection
        title="Join Our Team"
        description="Speak at Ai4 and become part of AI industry history. People attend Ai4 to learn how AI will impact their industry, their company, their career, and the world at large."
        buttonLabel="Register now"
        inputPlaceholder="Your Email"
      />
    </div>
  );
}

export default AboutUsPage;
